module.exports = __webpack_public_path__ + "media/components/assets/images/makeyourdream/moving_word_mobile-0ab32634e0ddca7db88a4460b9ab8afc.png";